import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=5dc6bf17&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.scss?vue&type=style&index=0&id=5dc6bf17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc6bf17",
  null
  
)

export default component.exports